import { Component, Input, SimpleChanges } from '@angular/core';
import {
    FieldError,
    OperationAuthorisation
} from '@flyfreely-portal-ui/flyfreely';

const NAMES = {
    startTime: 'Mission Time',
    'mission.missionCrew.rpic.jurisdiction': 'Pilot',
    'mission.visualLineOfSight': 'Visual Line of Sight'
};

@Component({
    selector: 'show-errors',
    templateUrl: './show-errors.component.html',
    styleUrls: ['./show-errors.component.scss']
})
export class ShowErrorsComponent {
    @Input()
    errors: { [control: string]: FieldError };
    @Input() authorisation: OperationAuthorisation;

    errorList: { name: string; message: string }[] = [];
    authorisationValidity: OperationAuthorisation.Validity =
        OperationAuthorisation.Validity.NA;
    validityLookup: { [validity: string]: string } = {
        [OperationAuthorisation.Validity.NA]: 'NA',
        [OperationAuthorisation.Validity.VALID]: 'Valid',
        [OperationAuthorisation.Validity.INVALID_AIRSPACE]: 'Invalid Airspace',
        [OperationAuthorisation.Validity.INVALID_MISSION]: 'Invalid Mission'
    };

    ngOnChanges(changes: SimpleChanges) {
        if ('errors' in changes) {
            if (this.errors == null) {
                this.errorList = [];
                return;
            } else {
                this.errorList = Object.keys(this.errors).map(identifier => ({
                    name: NAMES[identifier],
                    message: this.errors[identifier].message ?? 'invalid'
                }));
            }
        }
        if ('authorisation' in changes) {
            if (
                this.authorisation == null ||
                this.authorisation.validity == null
            ) {
                this.authorisationValidity = OperationAuthorisation.Validity.NA;
                return;
            } else {
                this.authorisationValidity = this.authorisation.validity;
            }
        }
    }
}
